import React from "react";
import PropTypes from "prop-types";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import CustomChip from "components/common/Chip";
import { getFormattedTimeAndDate } from "components/Screens/CommonUtils";

import "./ManualPaymentUpdate.scss";

function ManualPaymentUpdate({ audit, documents, onDownloadProof, paymentMethod, referenceNumber }) {
  const handleDownload = () => {
    if (onDownloadProof) {
      onDownloadProof();
    }
  };

  const isWireTransfer = paymentMethod === "wire";

  const updatedBy = `${audit?.userInfo?.firstName || ""} ${audit?.userInfo?.lastName || ""}`.trim() || "";
  const updatedOn = audit?.updatedAt ? getFormattedTimeAndDate(audit.updatedAt) : "";
  const note = audit?.note || "";
  const hasDocuments = Array.isArray(documents) && documents.length > 0;

  return (
    <div className="manual-payment-update-wrapper">
      <div className="manual-payment-update-header">
        <p className="manual-payment-update-header-text">The status for this payment was updated manually</p>
      </div>
      <div className="manual-payment-update-content">
        {updatedBy && (
          <div className="manual-payment-update-field">
            <p className="manual-payment-update-label">Updated by</p>
            <p className="manual-payment-update-value">{updatedBy}</p>
          </div>
        )}

        {updatedOn && (
          <div className="manual-payment-update-field">
            <p className="manual-payment-update-label">Updated on</p>
            <p className="manual-payment-update-value">{updatedOn}</p>
          </div>
        )}

        {isWireTransfer && referenceNumber && (
          <div className="manual-payment-update-field">
            <p className="manual-payment-update-label">Payment reference</p>
            <p className="manual-payment-update-value">{referenceNumber}</p>
          </div>
        )}

        {!isWireTransfer && hasDocuments && (
          <div className="manual-payment-update-field">
            <p className="manual-payment-update-label">Proof of payment</p>
            <CustomChip
              label="Download"
              onClick={handleDownload}
              endIcon={<FileDownloadOutlinedIcon />}
              size="small"
              variant="filled"
              color="default"
            />
          </div>
        )}

        {note && (
          <div className="manual-payment-update-field">
            <p className="manual-payment-update-label">Note</p>
            <p className="manual-payment-update-value">{note}</p>
          </div>
        )}
      </div>
    </div>
  );
}

ManualPaymentUpdate.propTypes = {
  audit: PropTypes.shape({
    user: PropTypes.string,
    updatedAt: PropTypes.string,
    note: PropTypes.string,
  }),
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      s3Key: PropTypes.string,
      size: PropTypes.number,
      path: PropTypes.string,
      contentType: PropTypes.string,
    })
  ),
  onDownloadProof: PropTypes.func,
  paymentMethod: PropTypes.string,
  referenceNumber: PropTypes.string,
};

ManualPaymentUpdate.defaultProps = {
  audit: {
    user: "",
    updatedAt: "",
    note: "",
  },
  documents: [],
  onDownloadProof: null,
  paymentMethod: "",
  referenceNumber: "",
};

export default ManualPaymentUpdate;
